<template>
  <div id="email-body" class="email contatto" style="position:absolute;top:0;left:0;"  >

    <table cellmargin="0" cellspacing="0" width="800" align="center" border="0" style="border:none;"><tr><td>


      <table cellmargin="0" cellspacing="0" width="800" align="center"><tr> 
        <td width="100%">
          <a href="https://www.sip.it/" style="margin:10px 0 0 20px;"><img src="https://nl.biomedia.net/nlweb/images/sip/head2013.png" style="width:800;border:none;"></a>
        </td>
      </tr></table>



      <table cellmargin="0" cellspacing="0" width="720" align="center"><tr> 
        <td style="margin:40px 0;">
          Gentile {{contatto.nome }} {{contatto.cognome }}
          <br /><br />
          Questa email è per confermarle le sue credenziali di accesso.
          <br /><br />
          <!--
          Email: {{contatto.email}}
          <br />
          Password: {{contatto.password}}
          -->
        </td>    
      </tr></table>

      <table cellmargin="8" cellspacing="8" width="780" align="center"><tr> 
        <tr>
          <td width="40%">
            <div style="text-align:center;">EMAIL</div>
          </td>
          <td width="60%">
            {{contatto.email}}
          </td>    
        </tr>

        <tr>
          <td width="40%">
            <div style="text-align:center;">PASSWORD</div>
          </td>
          <td width="60%">
            {{contatto.password}}
          </td>    
        </tr>

        <tr>
          <td width="40%">
            &#160;
          </td>
          <td width="60%">
            &#160;
          </td>    
        </tr>
      </table>







      <table cellmargin="0" cellspacing="0" width="800"><tr> 
        <td style="text-align:center;background:#666666;color:#ffffff;margin:20px;">
          La segreteria SIP
        </td>    
      </tr></table>


  </td ></tr></table>
</div>
</template>

<script>
export default {
   props: ['contatto'],
   beforeDestroy: function(){
     console.log("VM DISTRUTTA")
   }
}
</script>
